import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Authentication guard for Delivery Partner
 * Checks localStorage for deliveryPartner object
 * Redirects to login if missing or invalid
 */
const useAuthenticationCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const storedPartner = localStorage.getItem("deliveryPartner");

      if (!storedPartner) {
        navigate("/supplier/deliveryPartner/login", { replace: true });
        return;
      }

      const parsedPartner = JSON.parse(storedPartner);

      // Basic integrity check (adjust keys if needed)
      if (!parsedPartner?.id || !parsedPartner?.token) {
        localStorage.removeItem("deliveryPartner");
        navigate("/supplier/deliveryPartner/login", { replace: true });
      }
    } catch (error) {
      console.error("Authentication check failed:", error);
      localStorage.removeItem("deliveryPartner");
      navigate("/supplier/deliveryPartner/login", { replace: true });
    }
  }, [navigate]);
};

export default useAuthenticationCheck;
